import React, { useEffect, useState } from 'react'
import { Autocomplete, Chip, TextField } from '@mui/material'
import { debounce } from 'lodash'
import axios from 'axios'


export default function ModelSelect({ models, setModels, sx }) {
  const [mids, setMids] = useState(models.map(model => model.id));
  const [modelList, setModelList] = useState([]);
  const [selectedModels, setSelectedModels] = useState(Array.isArray(models) ? models : []);
  const [modelSearch, setModelSearch] = useState('');

  useEffect(() => {
    setSelectedModels(Array.isArray(models) ? models : []);
  }, [models]);

  const onInput = (e) => {
    const searchString = e.target.value
    if (searchString) {
      axios({
        method: "post",
        url: "/api/m2d/models/search",
        data: {
          attributes: ["id", "name", "version", "details"],
          status: "Approved",
          exMids: mids,
          searchString,
          limit: 5
        }
      }).then(res => {
        const ml = [...res.data].map(model => {
          return { label: `${model.name} (v${model.version})`, model: model }
        })
        setModelList(ml)
      })
    } else {
      setModelList([])
    }
  }

  const handleInput = debounce(onInput, 700)

  const handleSelect = (e, value) => {
    if (value) {
      const model = value.model
      const tmp = [...selectedModels]
      tmp.push({ id: model.id, name: model.name, version: model.version, details: model.details })
      setSelectedModels(tmp)
      const tmp2 = [...models]
      tmp2.push(model)
      setModels(tmp2)
      setMids(tmp.map(m => m.id))
    }
    setModelSearch('');
  }

  const handleDelete = (mid) => {
    setSelectedModels(curr => curr.filter(model => model.id !== mid))
    setModels(selectedModels.filter(model => model.id !== mid))
    setMids(selectedModels.filter(model => model.id !== mid).map(m => m.id))
  }

  return (
    <>
      <Autocomplete
        disablePortal
        options={modelList}
        sx={sx}
        renderInput={(params) => {
          return <TextField {...params} value={modelSearch} label="Models" />
        }}
        clearOnEscape
        onInput={handleInput}
        onChange={handleSelect}
      />
      <div className="model-display-area">
        {selectedModels.map((model) => {
          return (
            <Chip key={model.id}
              label={`${model.name} (v${model.version})`}
              onDelete={() => handleDelete(model.id)}
              sx={{ marginRight: '10px' }}
            />
          )
        })}
      </div>
      <style>
        {`
        .model-display-area {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 10px;
        }
        `}
      </style>
    </>
  )
}
